import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../content/CommonStyles.module.css";
import { useFormik } from "formik";
import useApi from "../../../Utils/BackendClient";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { TreeSelect } from "primereact/treeselect";
import { RadioButton } from "primereact/radiobutton";
import { DataTable } from 'primereact/datatable';
import { Column } from "primereact/column";
import { useState } from "react";
import { Tag } from "primereact/tag";
import ProductGroupFieldAddingSidebar from "./ProductGroupFieldAddingSidebar";
import TextInput from "../Inputs/TextInput";
import DropdownInput from "../Inputs/DropdownInput";
import { productStatusTranslation, TranslateFieldTypes } from "../../../Utils/TranslationUtils";
import { getGroupCode } from "../../../Utils/Utils";
import HistoryElement from "../HistoryElement";
import { DisplayErrors } from "../../../Utils/ErrorHandler";
import { TabMenu } from "primereact/tabmenu";

const ProductGroupCreationSidebar = ({ visible, onHide, toast, groups, onCreate, data, componentKey}) => {

    const { createProductGroup, fetchProductGroupHistory, updateProductGroup } = useApi();

    const [fieldAddingSidebarVisible, setFieldAddingSidebarVisible] = useState(false);
    const [groupHistory, setGroupHistory] = useState(null);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1   
    })
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [selectedAttribute, setSelectedAttribute] = useState(null);
    const [tabShowed, setTabShowed] = useState(0);

    const formik = useFormik({
        initialValues: data ?? {
            group_name: '',
            root_group: null,
            accounting_type: 'PIECE',
            identifier_name: '',
            description: '',
            is_active: null,
            attributes: [],
        },
        enableReinitialize : true,
        validate: values => {
            const errors = {};

            if (values.group_name === null || values.group_name === "") {
                errors.group_name = "Назва групи не повинна бути пустою";
            }

            if (values.accounting_type === 'INDIVIDUAL' && values.identifier_name === '') {
                errors.identifier_name = "Поле для ідентифікації не повинне бути пустим для індивідуального обліку";
            }

            return errors;
        },
        onSubmit: async (values) => {

            const payload = {
                ...values,
                is_active: String(values.is_active).toLowerCase() === "true",
                root_group: getGroupCode(values.root_group)
            }

            const response = data ? await updateProductGroup(data.id, payload) : await createProductGroup(payload);
            const successStatus = data ? 200 : 201;

            if (response.status === successStatus) 
            {
                const newGroupId = response.data.id;

                toast.current.show({ severity: "success", 
                    summary: data ? "Успіх редагування групи" : "Успіх створення групи", 
                    detail: data ? "Групу товарів успішно відредаговано" : "Групу товарів успішно створено", 
                    life: 3000 })
                formik.resetForm();
                onCreate(`${values.root_group}-${newGroupId}`);
                onHide();
            }
            else{
                DisplayErrors(response.error, toast);
            }
        }
    });

    const getGroupHistory = async (id, state) => {
        
        const response = await fetchProductGroupHistory(id, state);

        if(response.status === 200){
            setGroupHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else{
            DisplayErrors(response.error, toast);
        }
    }

    const items = [
        {
            label: 'Додаткові поля',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        ...(data
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(1);
                        getGroupHistory(formik.values?.id, historyLazyState);
                    },
                },
            ]
            : []),
    ];

    const DeleteFieldHandler = (id) => {
        const attributes = formik.values.attributes.filter(x => x.attribute_id !== id);
        formik.setFieldValue("attributes", attributes);
    }

    const EditAttribute = (data) => {
        setSelectedAttribute(data);
        setFieldAddingSidebarVisible(true);
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getGroupHistory(formik.values?.id, event);

        setHistoryLazyState(event);
    }

    const SetAttributeValue = (isEdit, attribute) => {

        if (isEdit) {
            const newAttributes = formik.values.attributes;
            const editedAttirbuteIndex = newAttributes.findIndex(x => x.attribute_id === attribute.attribute_id);
            newAttributes[editedAttirbuteIndex] = attribute;
            formik.setFieldValue("attributes", newAttributes);
        }
        else {
            const newAttributes = [...formik.values.attributes, attribute];
            formik.setFieldValue("attributes", newAttributes);
        }
    }

    const onFieldAddingSidebarHide = () => {
        setSelectedAttribute(null);
        setFieldAddingSidebarVisible(false);
    }

    const mainToolbarLeftTemplate = () => {

        const message = data ? "Редагування групи товарів " + data?.group_name : "Створення групи товарів"

        return <h3>{message}</h3>
    }

    const mainToolbarRightTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Зберегти" severity="success" className={commonStyle.addButton} type="submit" />
            </div>
        );
    }

    const rightToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap justify-content-end">
                <Button label="Додати" icon="pi pi-plus" type="button" className={commonStyle.addButton} onClick={() => setFieldAddingSidebarVisible(true)} severity="success" />
            </div>
        );
    };

    const ObligatoryBodyTemplate = (attribute) => {
        if (attribute.is_required) {
            return <Tag className={commonStyle.successTag} value='Так' severity="success" style={{ width: '20%' }} />;
        }

        return <Tag className={commonStyle.deletedTag} value="Ні" severity="danger" style={{ width: '20%' }}></Tag>;
    };

    const fieldsActionBodyTemplate = (rowData) => {
        if(!rowData.is_own){
            return;
        }
        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-pencil"
                type="button"
                className={`p-button-rounded p-button-info ${commonStyle.editButton}`}
                onClick={() => EditAttribute(rowData)}
            />
            <Button
                icon="pi pi-trash"
                type="button"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                onClick={() => DeleteFieldHandler(rowData.attribute_id)}
            />
        </div>
        );
    };

    return (
        <Sidebar visible={visible} position="right" onHide={onHide} className={commonStyle.pageSideBar} key={componentKey}>
            <form onSubmit={formik.handleSubmit}>
                <Toolbar className="mb-4" start={mainToolbarLeftTemplate} end={mainToolbarRightTemplate} />
                <div className="grid">
                    <div className="leftMenu col-3">
                        <TextInput formik={formik} paramName={"group_name"} label={"Назва групи"} mandatory /> 
                        <div className={commonStyle.formInput}>
                            <div className="p-inputgroup flex flex-column">
                                <FloatLabel>
                                    <TreeSelect
                                        name="root_group"
                                        value={formik.values.root_group}
                                        onChange={(e) => formik.setFieldValue('root_group', e.value)}
                                        options={groups}
                                        showClear
                                        className="w-full"
                                    />
                                    <label>Батьківська група</label>
                                </FloatLabel>
                            </div>
                        </div>
                        <DropdownInput 
                            formik={formik} 
                            paramName={"is_active"} 
                            onChange={(val) => formik.setFieldValue("is_active", val)} 
                            context={productStatusTranslation} 
                            label={"Статус"}/>
                        <div className="flex align-items-center">
                            <RadioButton value="PIECE" onChange={(e) => formik.setFieldValue("accounting_type", e.value)} checked={formik.values.accounting_type === "PIECE"} />
                            <label className="ml-2">Поштучний облік</label>
                        </div>
                        <div className="flex align-items-center mt-1">
                            <RadioButton value="INDIVIDUAL" onChange={(e) => formik.setFieldValue("accounting_type", e.value)} checked={formik.values.accounting_type === "INDIVIDUAL"} />
                            <label className="ml-2">Індивідуальний облік</label>
                        </div>
                        {formik.values.accounting_type === "INDIVIDUAL" && (<div>
                            <div className={commonStyle.formInput}>
                                <div className="p-inputgroup flex flex-column gap-1">
                                    <FloatLabel>
                                        <InputText
                                            name="idField"
                                            value={formik.values.identifier_name}
                                            onChange={(e) => { formik.setFieldValue('identifier_name', e.target.value) }}
                                            className={formik.errors.identifier_name && formik.touched.identifier_name ? 'p-invalid' : ''}
                                        />
                                        <label >Поле для ідентифікації</label>
                                    </FloatLabel>
                                    {formik.errors.identifier_name && formik.touched.identifier_name && (<small className={commonStyle.errorSmall}>{formik.errors.identifier_name}</small>)}
                                </div>
                            </div>
                        </div>)}
                    </div>
                    <div className="col-9">
                        <TabMenu model={items} />
                        {tabShowed === 0 &&<DataTable className="tableStyle" header={rightToolbarTemplate} value={formik.values.attributes} emptyMessage="Немає доданих атрибутів"
                             rows={10} tableStyle={{ minWidth: '60rem' }} >
                            <Column field="name" header="Назва" sortable />
                            <Column field="type" header="Тип" body={(rowData) => TranslateFieldTypes(rowData.type)}sortable />
                            <Column field="mandatory" dataType="bool" align="center" body={ObligatoryBodyTemplate} header="Обов'язковість" />
                            <Column field="action" body={fieldsActionBodyTemplate} />
                        </DataTable>}
                        {tabShowed === 1 && <HistoryElement data={groupHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={false}/>}
                    </div>
                </div>
            </form>
            <ProductGroupFieldAddingSidebar visible={fieldAddingSidebarVisible} onHide={() => onFieldAddingSidebarHide()} data={selectedAttribute} onSelect={(isEdit, val) => SetAttributeValue(isEdit, val)} toast={toast}/>
        </Sidebar>
    );
}

export default ProductGroupCreationSidebar;